const xdict = [
    'inexpensive-meal',
    'meal-for-two',
    'mcdonalds-combo-meal',
    'domestic-beer',
    'imported-beer',
    'capuccino',
    'coke-pepsi',
    'third-liter-water-bottle',
    'liter-milk',
    'bread-loaf',
    'kg-rice',
    'dozen-eggs',
    'kg-cheese',
    'kg-chicken-fillets',
    'kg-beef',
    'kg-apples',
    'kg-bananas',
    'kg-oranges',
    'kg-tomato',
    'kg-potato',
    'kg-onion',
    'head-lettuce',
    'one-and-a-half-liter-water-bottle',
    'bottle-wine',
    'domestic-beer-restaurant',
    'imported-beer-restaurant',
    'pack-cigarettes',
    'bus-ticket',
    'month-bus-pass',
    'taxi-start',
    'taxi-km',
    'taxi-hour-waiting',
    'liter-gas',
    'volkswagen-golf',
    'toyota-corolla-sedan',
    'monthly-apartment-utilities',
    'local-mobile-tariff-minute',
    'month-internet',
    'month-gym-membership',
    'hour-tennis-court',
    'movie-ticket',
    'preschool-month',
    'international-school-yearly',
    'levis-jeans',
    'summer-dress',
    'running-shoes',
    'business-shoes',
    'apartment-monthly-rent-city-centre',
    'apartment-monthly-rent-outside-city-centre',
    'three-bed-apartment-monthly-rent-city-centre',
    'three-bed-apartment-monthly-rent-outside-city-centre',
    'month-rent-per-sqm-city-centre',
    'month-rent-per-sqm-outside-city-centre',
    'avg-montly-salary-after-tax',
    'twenty-year-mortgage-interest-rate',
    'pizza',
    'burger',
    'big-mac',
    "gdp-billions"
];

const ingredients = ['Inexpensive Meal', 'Meal for 2 (3-Course)', 'McMeal', 'Domestic Beer (Rest)', 'Imported Beer (Rest)', 'Cappuccino (Rest)', 'Coke/Pepsi (Rest)', 'Water (Rest)', 'Milk', 'Loaf of Bread', 'Rice', 'Eggs', 'Cheese', 'Chicken Breasts', 'Beef Round', 'Apples', 'Banana', 'Oranges', 'Tomato',
    'Potato', 'Onion', 'Lettuce', 'Water (1.5L Store)', 'Bottle of Wine (Store)', 'Domestic Beer (Store)', 'Imported Beer (Store)', 'Cigarettes 20 Pack', 'One-way Ticket (Local Transport)', 'Monthly Pass (Regular Price)', 'Taxi Start', 'Taxi 1km', 'Taxi 1hour Waiting', 'Gasoline (1L)', 'Volkswagen Golf 1.4 90 KW Trendline (Or Equivalent New Car)',
    'Toyota Corolla Sedan 1.6l 97kW Comfort (Or Equivalent New Car)', 'Basic (Electricity, Heating, Cooling, Water, Garbage) for 85m2 Apartment', '1 min. of Prepaid Mobile Tariff Local (No Discounts or Plans)', 'Internet (60 Mbps or More, Unlimited Data, Cable/ADSL)', 'Fitness Club, Monthly Fee for 1 Adult', 'Tennis Court Rent (1 Hour on Weekend)',
    'Cinema, International Release, 1 Seat', 'Preschool (or Kindergarten), Full Day, Private, Monthly for 1 Child', 'International Primary School, Yearly for 1 Child', '1 Pair of Jeans (Levis 501 Or Similar)', '1 Summer Dress in a Chain Store (Zara, H&M, ...)', '1 Pair of Nike Running Shoes (Mid-Range)',
    '1 Pair of Men Leather Business Shoes', 'Apartment (1 Bedroom) in City Center', 'Apartment (1 Bedroom) Outside of Center', 'Apartment (3 Bedrooms) in City Center', 'Apartment (3 Bedrooms) Outside of Center', 'Price per Square Meter to Buy Apartment in City Center',
    'Price per Square Meter to Buy Apartment Outside of Center', 'Average Monthly Net Salary (After Tax)', 'Mortage Interest Rate in Percentages, for 20 Years Fixed-Rate', 'Pizza', 'Burger', 'Big Mac',"GDP in Billions"];

const unique_countries = [
    "Pakistan",
    "Mozambique",
    "Haiti",
    "Algeria",
    "Jersey",
    "Russia",
    "Armenia",
    "Burundi",
    "Zambia",
    "New Zealand",
    "Cameroon",
    "Greenland",
    "Rwanda",
    "Reunion",
    "French Polynesia",
    "Vanuatu",
    "Switzerland",
    "Nauru",
    "Somalia",
    "Vatican City",
    "Bolivia",
    "Ivory Coast",
    "Latvia",
    "Colombia",
    "New Caledonia",
    "Equatorial Guinea",
    "Djibouti",
    "Sweden",
    "North Korea",
    "Taiwan",
    "Montenegro",
    "Andorra",
    "Morocco",
    "Belarus",
    "Bahamas",
    "Vietnam",
    "Bahrain",
    "Iran",
    "Peru",
    "Saint Kitts And Nevis",
    "Timor-Leste",
    "Italy",
    "Dominican Republic",
    "Iraq",
    "Liechtenstein",
    "Laos",
    "French Guiana",
    "Ireland",
    "Saudi Arabia",
    "Ethiopia",
    "Japan",
    "British Virgin Islands",
    "Martinique",
    "Samoa",
    "Saint Helena",
    "India",
    "Sudan",
    "Mali",
    "Hong Kong",
    "Mongolia",
    "Luxembourg",
    "Chile",
    "Gibraltar",
    "Turkey",
    "Guyana",
    "Belize",
    "Denmark",
    "France",
    "Saint Vincent And The Grenadines",
    "Zimbabwe",
    "Serbia",
    "Bangladesh",
    "Bulgaria",
    "Albania",
    "Fiji",
    "United Kingdom",
    "Germany",
    "Belgium",
    "Lesotho",
    "Tanzania",
    "Togo",
    "Madagascar",
    "Marshall Islands",
    "South Sudan",
    "Comoros",
    "Suriname",
    "Netherlands",
    "Mexico",
    "Poland",
    "Monaco",
    "Qatar",
    "Benin",
    "Papua New Guinea",
    "Cook Islands",
    "Spain",
    "Myanmar",
    "Nigeria",
    "Senegal",
    "American Samoa",
    "Croatia",
    "Ghana",
    "Uganda",
    "Bhutan",
    "Anguilla",
    "Liberia",
    "Iceland",
    "Gambia",
    "Panama",
    "Indonesia",
    "Antigua And Barbuda",
    "Chad",
    "Tajikistan",
    "Eritrea",
    "Malawi",
    "Guinea-Bissau",
    "Sri Lanka",
    "Curacao",
    "Lebanon",
    "Azerbaijan",
    "Uzbekistan",
    "Cuba",
    "Thailand",
    "Kuwait",
    "Czech Republic",
    "North Macedonia",
    "Estonia",
    "Turkmenistan",
    "Kenya",
    "Norway",
    "China",
    "Honduras",
    "Slovakia",
    "Australia",
    "Angola",
    "Kazakhstan",
    "Libya",
    "Solomon Islands",
    "Bermuda",
    "Congo",
    "Tuvalu",
    "South Africa",
    "Nicaragua",
    "Cyprus",
    "Yemen",
    "Swaziland",
    "Sao Tome And Principe",
    "Ecuador",
    "Philippines",
    "Austria",
    "Sint Maarten",
    "Sierra Leone",
    "Isle Of Man",
    "United States",
    "Tonga",
    "Dominica",
    "Turks And Caicos Islands",
    "Cape Verde",
    "Montserrat",
    "Egypt",
    "Nepal",
    "Moldova",
    "Portugal",
    "Maldives",
    "South Korea",
    "Brunei",
    "Guinea",
    "Oman",
    "Paraguay",
    "Malaysia",
    "Greece",
    "Afghanistan",
    "Argentina",
    "Georgia",
    "Brazil",
    "Trinidad And Tobago",
    "Falkland Islands",
    "Jordan",
    "Canada",
    "Tunisia",
    "Gabon",
    "Hungary",
    "Kyrgyzstan",
    "Saint Lucia",
    "Syria",
    "Finland",
    "Venezuela",
    "Burkina Faso",
    "Ukraine"
  ];

export function ingredientToXdict(ingredient) {
    return xdict[ingredients.indexOf(ingredient)];
}

export function xdictToIngredient(xdictItem) {
    return ingredients[xdict.indexOf(xdictItem)];
}

export function xdictArray(){
    return xdict;
}

export function uniqueCountries(){
    return unique_countries;
}